<!-- @format -->

<template>
	<el-dialog
		ref="dialog"
		v-model="dialogVisible"
		:title="title"
		:show-close="showClose"
		:close-on-click-modal="closeOnClickModal"
		:close-on-press-escape="closeOnPressEscape"
		:fullscreen="fullscreen"
		:top="marginTop"
		:width="width"
		class="pcp-selector-dialog"
		:is-custom-dialog="isCustomDialog"
		:preview-fullscreen="previewFullscreen"
		@fullscreen="handleFullscreen"
		@open="handleOpen"
		@opened="handleOpened"
		@close="handleClose"
	>
		<slot name="title" />
		<div :style="{ height: multiple ? '70px' : '40px' }" class="pc-selector-header">
			<template v-for="(item, index) in selectedItems">
				<el-tag
					v-if="$utils.isNotEmpty(item)"
					:key="item + index"
					closable
					disable-transitions
					@close="handleRemove(index)"
				>
					{{ item }}
				</el-tag>
			</template>
		</div>
		<slot v-if="dialogVisible" :multiple="multiple" :height="height" :value="value" />
		<template #footer>
			<pc-toolbar
				v-if="buttonGroup && buttonGroup.length > 0"
				position="buttom"
				:identity="identity"
				:actions="buttonGroup"
				@action-event="handleActionEvent"
			/>
		</template>
	</el-dialog>
</template>
<script>
	import { PcToolbar } from '@/components/pc-toolbar/index';
	import { ActionUtils } from '@/p-components/pcp-org-selector/action';
	import { $utils } from '@/utils/publicUtils';
	export default {
		components: {
			PcToolbar,
		},
		props: {
			// 是否可见
			visible: Boolean,
			// 标题
			title: {
				type: String,
			},
			// Dialog CSS 中的 margin-top 值
			marginTop: {
				type: String,
				default: '15vh',
			},
			// 宽
			width: {
				type: String,
				default: '60%',
			},
			// 高
			height: {
				type: String,
				default: '400px',
			},
			// 是否可以通过点击 modal 关闭 Dialog
			closeOnClickModal: {
				type: Boolean,
				default: false,
			},
			// 是否可以通过按下 ESC 关闭 Dialog
			closeOnPressEscape: {
				type: Boolean,
				default: false,
			},
			// 是否显示关闭按钮
			showClose: {
				type: Boolean,
				default: true,
			},
			// 是否自定义对话框
			isCustomDialog: {
				type: Boolean,
				default: false,
			},
			// 是否全屏按钮
			previewFullscreen: {
				type: Boolean,
				default: false,
			},
			// 关闭前的回调，会暂停 Dialog 的关闭
			beforeClose: {
				type: Function,
			},
			// 是否为全屏 Dialog
			fullscreen: {
				type: Boolean,
				default: false,
			},
			// 展示的值
			labelKey: {
				type: [String, Function],
				default: 'name',
			},
			// 值
			value: {
				type: [Object, Array],
				default: () => {
					// return this.multiple ? [] : {};
				},
			},
			// 按钮清空并关闭
			cleanClose: {
				type: Boolean,
				default: false,
			},
			defaultButton: {
				type: Boolean,
				default: true,
			},
			// 按钮组
			buttons: {
				type: Array,
				default() {
					return [];
				},
			},
			// 按钮位置
			placement: {
				type: String,
				default: 'right',
			},
			confirmButtonText: {
				type: String,
			},
			cleanButtonText: {
				type: String,
			},
			cancelButtonText: {
				type: String,
			},
			// 是否多选
			multiple: {
				type: Boolean,
				default: false,
			},
			// 标识
			identity: {
				type: String,
			},
		},
		data() {
			return {
				dialogVisible: this.visible,
				$utils,
			};
		},
		computed: {
			selectedItems() {
				if ($utils.isEmpty(this.value)) {
					return [];
				}
				if (this.multiple) {
					const items = [];
					const valueArr = Object.assign([], this.value);
					valueArr.forEach((item) => {
						items.push(this.handleLabel(item));
					});
					return items;
				} else {
					const value = $utils.isArray(this.value) ? this.value[0] : this.value;
					return [this.handleLabel(value)];
				}
			},
			buttonGroup() {
				let buttons = [];
				if ($utils.isEmpty(this.buttons) && this.defaultButton) {
					buttons = buttons.concat([
						{
							key: 'confirm',
							size: 'default',
							label: this.confirmButtonText || '选择',
							type: 'primary',
							action: () => this.handleOk(),
						},
						{ key: 'clean', size: 'default', label: this.cleanButtonText || '清空', action: () => this.handleClean() },
						{
							key: 'cancel',
							size: 'default',
							label: this.cancelButtonText || '取消',
							action: () => this.handleCancel(),
						},
					]);
				} else {
					buttons = this.buttons;
				}
				if ($utils.isEmpty(buttons)) {
					return [];
				}
				return buttons.map((button) => {
					const action = button.action;
					const label = button.label;
					if (action) {
						button.action = (e) => action(() => {}, this, e);
					}
					if (label) {
						button.label = label;
					}
					return button;
				});
			},
		},
		watch: {
			visible: {
				handler() {
					this.dialogVisible = this.visible;
				},
				immediate: true,
			},
		},
		methods: {
			handleLabel(data) {
				const config = this.labelKey;
				if (typeof config === 'function') {
					return config(data);
				} else if (typeof config === 'string') {
					return data ? data[config] : '';
				} else if (typeof config === 'undefined') {
					const dataProp = data ? data['name'] : undefined;
					return dataProp === undefined ? '' : dataProp;
				}
			},
			// 确定
			handleOk() {
				const data = this.multiple ? this.value.slice(0) : this.value;
				if ($utils.isEmpty(data)) {
					ActionUtils.warning('请选择记录！');
					return;
				}
				this.$emit('inputMain', data);
				this.$emit('action-event', 'confirm', data);
			},
			// 清空
			handleClean() {
				const data = this.multiple ? [] : {};
				if (!this.cleanClose) {
					this.$emit('inputMain', data);
				}
				this.$emit('action-event', 'clean', data);
			},
			// 取消
			handleCancel() {
				this.handleClose();
				this.$emit('action-event', 'cancel');
			},
			// 关闭窗口
			handleClose() {
				this.$emit('close', false);
			},
			// 打开窗口
			handleOpen() {
				this.$emit('open');
			},
			// 打开窗口后
			handleOpened() {
				this.$emit('opened');
			},
			// 全屏
			handleFullscreen(val) {
				this.$emit('fullscreen', val);
			},
			// 删除
			handleRemove(index) {
				let res;
				let removeValue;
				if (this.multiple) {
					const selected = JSON.parse(JSON.stringify(this.value));
					selected.splice(index, 1);
					res = selected;
					removeValue = this.value[index];
				} else {
					res = {};
					removeValue = res;
				}
				this.$emit('inputMain', res);
				this.$emit('remove-select', removeValue, index);
			},
			// 处理按钮的事件
			handleActionEvent(button, position, data, index) {
				if (button.emit) {
					this.$emit(button.emit, {
						key: button.key,
						index,
						row: data,
						position,
						action: button,
					});
				}
				button.action();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.pc-selector-header {
		line-height: 32px;
		overflow: auto;
		box-sizing: border-box;
		border: 1px dashed #ccc;
		border-radius: 1px;
		margin: 5px 2px;
	}

	.pc-selector-header .el-tag {
		vertical-align: middle;
		margin: 0 5px;
	}
</style>

<style lang="scss">
	.pcp-selector-dialog {
		.el-dialog__body {
			height: calc(100% - 125px);
			overflow-y: auto;
		}
	}
</style>
